import { cva } from "cva";

export const carouselNavigationStyles = cva({
  base: "flex items-center justify-between absolute top-1/2 left-0 right-0 -translate-y-1/2 px-xl z-2 pointer-events-none [&_button]:pointer-events-auto",
});

export const carouselProgressContainerStyles = cva({
  base: "mds-container mds-grid",
});

export const carouselProgressTrackStyles = cva({
  base: "col-span-full lg:col-span-10 lg:col-start-2 w-full h-4 bg-ink-200 rounded-full overflow-hidden",
});

export const carouselProgressBarStyles = cva({
  base: "w-full h-full bg-content-primary scale-x-[var(--mds-carousel-progress)] origin-left will-change-transform",
});

export const carouselPaginationDotsStyles = cva({
  base: "relative flex items-center bg-ink-200 self-center rounded-full",
});

export const carouselPaginationDotStyles = cva({
  base: [
    "cursor-pointer px-4 py-10 rounded-full transition-colors duration-220 ease-out-quad",
    "first:pl-10 last:pr-10",
    "after:content-[''] after:block after:size-8 after:rounded-full after:bg-current",
  ],
  variants: {
    active: {
      true: "text-content-primary",
      false: "text-ink-400/80 hover:text-ink-500",
    },
  },
});
